import ImageRotator from "./ImageRotator";
import { useState, useEffect } from "react";

const RotatorWrapper = (props) => {
  let {cardArray, type} = props;
  let left = [];
  let center = [];
  let right = [];
  let newCardArray = [];

  let cardArrayCopy = cardArray;

  let originalLength = cardArray.length;
  for (let i = 0; i < originalLength; i++) {
    newCardArray.push(cardArrayCopy[i]);
  }

  let summedArray = newCardArray.concat(cardArrayCopy);

  if (type==="workAreas" || type==="projects"){
    summedArray.push(...cardArray);
  }

  let remainder = summedArray.length % 3;
  if (remainder !== 0) {
    summedArray = summedArray.slice(0, summedArray.length - remainder);
  }

  let boxOrder = [left, center, right];
  let currentBoxIndex = 0;
  for (let i = 0; i < summedArray.length; i++) {
    let currentItem = summedArray[i];
    let currentBox = boxOrder[currentBoxIndex];
    currentBox.push(currentItem);
    currentBoxIndex = (currentBoxIndex + 1) % 3;
  }

  let delay = 7;
  const [trigger, setTrigger] = useState(0);
  const [activeRotator, setActiveRotator] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTrigger(Math.random());
      setActiveRotator(Math.floor(Math.random() * 3));
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <ImageRotator 
        animationLength={12}
        delay={delay}
        offset={1}
        cardArray={left}
        type={type}
        trigger={trigger}
        isActive={activeRotator === 0}
      />
      <ImageRotator 
        animationLength={12}
        delay={delay}
        offset={5}
        cardArray={center}
        type={type}
        trigger={trigger}
        isActive={activeRotator === 1}
      />
      <ImageRotator 
        animationLength={12}
        delay={delay}
        offset={9}
        cardArray={right}
        type={type}
        trigger={trigger}
        isActive={activeRotator === 2}
      />
    </>
  );
};

export default RotatorWrapper;
